import { AppointmentTooltip } from "@devexpress/dx-react-scheduler-material-ui";
import {
  HourglassOutlined,
  HomeOutlined,
  DesktopOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import { capitalize } from "../../utils/string";
// @typescript-eslint/explicit-module-boundary-types
export const BookingTooltipContent = (data: any, showUserInfo = true) => {
  const { children, appointmentData, classes, ...restProps } = data;
  return (
    <AppointmentTooltip.Content
      {...restProps}
      appointmentData={appointmentData}
    >
      {appointmentData.branch && <div className="booking-detail-item-wrapper" style={{ marginTop: 5 }}>
        <div
          className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
          style={{ paddingTop: 3, textAlign: "center" }}
        >
          <HomeOutlined style={{ fontSize: 20 }} />
        </div>
        {appointmentData.branch}
      </div>}
      {showUserInfo && (
        <div className="booking-detail-item-wrapper">
          <div
            className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
            style={{ paddingTop: 3, textAlign: "center" }}
          >
            <UserOutlined style={{ fontSize: 20 }} />
          </div>
          {appointmentData.user.fullName}
        </div>
      )}
      {showUserInfo && appointmentData.user.email && (
        <div className="booking-detail-item-wrapper">
          <div
            className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
            style={{ paddingTop: 3, textAlign: "center" }}
          >
            <MailOutlined style={{ fontSize: 18 }} />
          </div>
          {appointmentData.user.email}
        </div>
      )}
      {showUserInfo && appointmentData.user.phoneNumber && (
        <div className="booking-detail-item-wrapper">
          <div
            className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
            style={{ paddingTop: 3, textAlign: "center" }}
          >
            <PhoneOutlined style={{ fontSize: 20 }} />
          </div>
          {appointmentData.user.phoneNumber}
        </div>
      )}
      {!showUserInfo &&
        <div className="booking-detail-item-wrapper">
          <div
            className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
            style={{ paddingTop: 3, textAlign: "center" }}
          >
            <DesktopOutlined style={{ fontSize: 20 }} />
          </div>
          {appointmentData.court.name}({capitalize(appointmentData.court.place)})
        </div>
      }
      <div className="booking-detail-item-wrapper">
        <div
          className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
          style={{ paddingTop: 3, textAlign: "center" }}
        >
          <HourglassOutlined style={{ fontSize: 20 }} />
        </div>
        {appointmentData.period} mins
      </div>
      <div className="booking-detail-item-wrapper">
        <div
          className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
          style={{ paddingTop: 3, textAlign: "center" }}
        >
          <AuditOutlined style={{ fontSize: 20 }} />
        </div>
        {appointmentData.price} {appointmentData.currency}
      </div>
      <div className="booking-detail-item-wrapper">
        <div
          className="MuiGrid-grid-xs-2 makeStyles-textCenter-200"
          style={{ paddingTop: 3, textAlign: "center", flexBasis: "100%", maxWidth: "100%" }}
        >
          <span>{appointmentData.additionalInfo}</span>
        </div>
      </div>
    </AppointmentTooltip.Content>
  );
};
